import { HeatLoadCalculationMethod } from '@customer-apps/shared/enums';
import { EnumDictionary } from '@customer-apps/shared/utils';

export const CalculationMethodDictionary: EnumDictionary<HeatLoadCalculationMethod, string> = {
    [HeatLoadCalculationMethod.BuildingHull]: 'buildingHull',
    [HeatLoadCalculationMethod.Consumption]: 'consumption',
    [HeatLoadCalculationMethod.EnergyCertificate]: 'energyCertificate',
    [HeatLoadCalculationMethod.LivingSpace]: 'livingArea',
    [HeatLoadCalculationMethod.CustomValue]: 'customValue'
};
